// extracted by mini-css-extract-plugin
export default {"footerBg":"f-z","footerTopLinks":"g-z","footerFeedback":"h-z","footerSocial":"i-z","footerLegalLinks":"j-z","footerIconCards":"k-z","footerBotCopy":"l-z"};